import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddNotePayload,
  AddNoteResponse,
  AddTimesheetResponse,
  ApproveTimesheetPayload,
  ChangeRate,
  NotesPaylod,
  NotesResponse,
  Timesheet,
  TimesheetChangeCMPayload,
  TimesheetCommonResponse,
  TimesheetPayload,
  TimesheetReportPayload,
  TimesheetResponse,
} from '@core/interface/timesheet';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService {
  constructor(private http: HttpClient) {}
  getTimesheets(filter?: TimesheetPayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof TimesheetPayload] as any) || ''
        );
      });
    return this.http.get<TimesheetResponse>(
      environment.endPoints.timesheetList,
      {
        params: httpParams,
      }
    );
  }

  addTimesheet(data: Timesheet) {
    return this.http.post<AddTimesheetResponse>(
      environment.endPoints.timesheetAddEdit,
      data
    );
  }
  deleteTimesheet(id: number) {
    return this.http.get<TimesheetCommonResponse>(
      environment.endPoints.timesheetDelete(id)
    );
  }

  getTimesheetWeekly() {
    return this.http.get<TimesheetResponse>(
      environment.endPoints.timesheetWeekly
    );
  }

  approveTimesheet(filter?: ApproveTimesheetPayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof ApproveTimesheetPayload] as any) || ''
        );
      });
    return this.http.get<TimesheetResponse>(
      environment.endPoints.timesheetApprove,
      {
        params: httpParams,
      }
    );
  }

  addAuditNote(data: AddNotePayload) {
    return this.http.post<AddNoteResponse>(environment.endPoints.addNote, data);
  }

  getAuditNotes(filter?: NotesPaylod) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof NotesPaylod] as any) || ''
        );
      });
    return this.http.get<NotesResponse>(environment.endPoints.notesList, {
      params: httpParams,
    });
  }

  reOpenTimesheet(filter?: TimesheetPayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof TimesheetPayload] as any) || ''
        );
      });
    return this.http.get<TimesheetCommonResponse>(
      environment.endPoints.timesheetReopen,
      {
        params: httpParams,
      }
    );
  }

  getTimesheetReport(filter?: TimesheetReportPayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof TimesheetReportPayload] as any) || ''
        );
      });
    return this.http.get<TimesheetResponse>(
      environment.endPoints.timesheetReport,
      {
        params: httpParams,
      }
    );
  }

  unsubmitTimesheet(filter?: NotesPaylod) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof NotesPaylod] as any) || ''
        );
      });
    return this.http.get<NotesResponse>(
      environment.endPoints.timesheetUnsubmit,
      {
        params: httpParams,
      }
    );
  }

  chnageCM(filter?: TimesheetChangeCMPayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof TimesheetChangeCMPayload] as any) || ''
        );
      });
    return this.http.get<TimesheetResponse>(
      environment.endPoints.timesheetChangeCM,
      {
        params: httpParams,
      }
    );
  }

  adminDirectApprove(ids: string) {
    return this.http.post<TimesheetCommonResponse>(
      environment.endPoints.adminDirectApprove,
      { ids },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  storeOvertimeManual(data: ChangeRate[]) {
    return this.http.post<TimesheetCommonResponse>(
      environment.endPoints.storeManualOvertime,
      data
    );
  }
}
